export default {"src":"/_next/static/media/11.c544ea70.svg","height":25,"width":25};